import { isContentFragment, } from '../content-types';
import { getLoadableContentPaths } from './utils';
export async function fetchContent(contentPath, contentApiConfig, logger, requestId) {
    try {
        const response = await fetch(`${contentApiConfig.origin}${contentApiConfig.path}?path=${encodeURIComponent(contentPath)}`, {
            headers: typeof contentApiConfig.customConfig?.apiKey === 'string'
                ? {
                    'X-API-KEY': contentApiConfig.customConfig.apiKey,
                }
                : {},
        });
        if (!response.ok) {
            throw new Error(`${response.status} - ${response.statusText}\n${await response.text()}`);
        }
        const content = await response.json();
        if (!isContentFragment(content.data)) {
            throw new Error(`Content is not a Content Fragment:\n${JSON.stringify(content, undefined, 2)}`);
        }
        return content.data;
    }
    catch (error) {
        if (logger) {
            logger.error(`Cannot load content for ${contentPath}${requestId ? ` (${requestId})` : ''}`, error);
        }
        throw error;
    }
}
export async function prefetchContentContainers(contentPaths, contentApiConfig, logger) {
    const items = Array.isArray(contentPaths) ? contentPaths : [contentPaths];
    const uniqueContentPaths = getLoadableContentPaths(items, {});
    return Object.fromEntries(await Promise.all(uniqueContentPaths.map(async (contentPath) => {
        try {
            return [
                contentPath,
                (await fetchContent(contentPath, contentApiConfig, logger, 'prefetch')),
            ];
        }
        catch (e) {
            return [contentPath, e];
        }
    })));
}
//# sourceMappingURL=fetch.js.map